import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreMatriculaService {

  private apiUrl = environment.apiPortalPais;

  constructor(private http: HttpClient) { }

  buscarAlunosPreMatriculas(alunosIds: number[]): Observable<HttpResponse<any>> {
    return this.http.post(
      `${this.apiUrl}/api/prematricula/buscarprematriculas`, alunosIds,
      { observe: 'response' }
    )
  }

  consultarResponsavelFinanceiroPorAlunoId(alunoId: number): Observable<HttpResponse<any>> {
    return this.http.get(
      `${this.apiUrl}/api/prematricula/consultaresponsavelfinanceiroporalunoid/${alunoId}`,
      { observe: 'response' }
    )
  }

  VerificaAnoLetivoPreMatricula(alunosIds: number[]): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    alunosIds.forEach(id => {
      params = params.append('alunosIds', id);
    });

    return this.http.post(
      `${this.apiUrl}/api/prematricula/verificaanoletivo`, alunosIds,
      { observe: 'response'}
    )
  }

  buscarTurmasDisponiveis(alunoId: number, anoLetivoId: number): Observable<HttpResponse<any>> {
    return this.http.get(
      `${this.apiUrl}/api/prematricula/turmasdisponiveis/${alunoId}/${anoLetivoId}`,
      { observe: 'response' }
    )
  }

  salvarPreMatricula(preMatricula: any): Observable<HttpResponse<any>> {
    const req = {
      preMatricula: preMatricula,
      responsavelPais: preMatricula.responsavelPais,
      responsavelPaisId: preMatricula.responsavelPaisId
    }

    return this.http.post(
      `${this.apiUrl}/api/prematricula/salvarPreMatricula`, req,
      { observe: 'response', }
    )
  }

  put(preMatricula: any): Observable<HttpResponse<any>> {

    return this.http.put(
      `${this.apiUrl}/api/prematricula/atualiza/` + preMatricula.preMatriculaId, preMatricula,
      { observe: 'response', }
    )
  }

  putPreMatriculaContaParcelaStatus(itemId: any, item: any): Observable<HttpResponse<any>> {

    return this.http.put(
      `${this.apiUrl}/api/prematricula/atualizastatuscontaparcela/` + itemId, item,
      { observe: 'response', }
    )
  }

  // // Criar nova pré-matrícula
  // criarPreMatricula(preMatricula: PreMatricula): Observable<HttpResponse<any>> {
  //   return this.http.post<any>(
  //     `${this.apiUrl}/api/prematricula/inclui`,
  //     preMatricula,
  //     { observe: 'response' }
  //   ).pipe(
  //     catchError(this.handleError)
  //   );
  // }

  // // Atualizar pré-matrícula existente
  // atualizarPreMatricula(preMatricula: PreMatricula, id: number): Observable<HttpResponse<any>> {
  //   return this.http.put<any>(
  //     `${this.apiUrl}/api/prematricula/atualiza/${id}`,
  //     preMatricula,
  //     { observe: 'response' }
  //   ).pipe(
  //     catchError(this.handleError)
  //   );
  // }

  // // Buscar pré-matrículas do responsável
  // buscarPreMatriculas(): Observable<PreMatricula[]> {
  //   return this.http.get<PreMatricula[]>(
  //     `${this.apiUrl}/api/prematricula/lista`
  //   ).pipe(
  //     catchError(this.handleError)
  //   );
  // }

  // // Buscar turmas disponíveis para rematrícula
  // buscarTurmasDisponiveis(matriculaId: number): Observable<Turma[]> {
  //   return this.http.get<Turma[]>(
  //     `${this.apiUrl}/api/turma/disponiveis/${matriculaId}`
  //   ).pipe(
  //     catchError(this.handleError)
  //   );
  // }

  // // Buscar preços da turma
  // buscarPrecosTurma(turmaId: number): Observable<TurmaPreco[]> {
  //   return this.http.get<TurmaPreco[]>(
  //     `${this.apiUrl}/api/turma/${turmaId}/precos`
  //   ).pipe(
  //     catchError(this.handleError)
  //   );
  // }

  // // Buscar condições de pagamento
  // buscarCondicoesPagamento(turmaPrecoId: number): Observable<CondicaoPagamento[]> {
  //   return this.http.get<CondicaoPagamento[]>(
  //     `${this.apiUrl}/api/turmapreco/${turmaPrecoId}/condicoes-pagamento`
  //   ).pipe(
  //     catchError(this.handleError)
  //   );
  // }

  // // Buscar dados do aluno/matrícula
  // buscarDadosMatricula(matriculaId: number): Observable<any> {
  //   return this.http.get<any>(
  //     `${this.apiUrl}/api/matricula/${matriculaId}`
  //   ).pipe(
  //     catchError(this.handleError)
  //   );
  // }
}

